import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Salon: React.FC<IconProps> = ({
  color = "#2625e9",
  size = 40,
  className,
  style,
  ...props
}) => (
  <svg
    transform="scale(1.5)"
    viewBox="0 0 80 80"
    style={{ width: size, height: size, flexShrink: 0, ...style }}
    aria-hidden="true"
    className={className}
    {...props}
  >
<g transform="translate(0,-0)">
    <path
      d="M58.97 63.64H35.15a.58.58 0 010-1.16h23.58c2.09-2.14 2.84-4.48 2.23-6.95-.47-1.87-2.39-3.11-4.48-2.89L32.3 54.66c-.32.03-.6-.21-.62-.53s.21-.6.53-.62l24.16-2.02c2.65-.28 5.11 1.33 5.71 3.76.5 2.04.44 5.12-2.71 8.22-.11.11-.25.17-.41.17z"
      fill={color}
    />
    <path
      d="M31.76 54.7c-.13 0-.26-.04-.36-.13a.574.574 0 01-.09-.81 6.417 6.417 0 001.22-2.51c.48-1.89.07-3.92-1.13-5.56-1.64-2.25-4.59-7.1-5.94-14.35v-.03c0-.02-.27-1.89-1.57-2.7-.76-.47-1.77-.5-2.98-.08-.19.09-2.24 1.08-1.43 4.01l5.76 19.14c.09.31-.08.63-.39.72a.575.575 0 01-.72-.39l-5.77-19.16c-1.11-4.03 2.08-5.39 2.12-5.41.01 0 .02 0 .03-.01 1.57-.54 2.92-.48 4 .19 1.71 1.06 2.07 3.27 2.1 3.51 1.3 7.02 4.15 11.7 5.73 13.86 1.4 1.92 1.88 4.29 1.32 6.52-.19.78-.5 1.52-.9 2.18-.15.26-.34.51-.54.77-.11.14-.28.21-.45.21z"
      fill={color}
    />
    <path
      d="M21.26 28.41a.58.58 0 01-.58-.58v-3.9a.58.58 0 011.16 0v3.9c0 .32-.26.58-.58.58zM18.71 31.92a.58.58 0 01-.58-.58v-7.42a.58.58 0 011.16 0v7.42c0 .32-.26.58-.58.58z"
      fill={color}
    />
    <path
      d="M22.64 24.51h-3.52c-.8 0-1.45-.65-1.45-1.45v-9.91c0-.32.26-.58.58-.58 4.19 0 6.59 2.48 6.59 6.81v2.11c0 1.27 0 3.01-2.2 3.01zm-3.81-10.76v9.31c0 .16.13.29.29.29h3.52c.86 0 1.05-.16 1.05-1.86v-2.11c0-3.49-1.67-5.43-4.85-5.64zM57.18 67.41H36.57a.58.58 0 010-1.16h20.61c.53 0 .95-.43.95-.95v-2.25a.58.58 0 011.16 0v2.25c0 1.16-.95 2.11-2.11 2.11z"
      fill={color}
    />
    <path
      d="M36.59 67.43h-9.73c-.28 0-.51-.19-.57-.47l-2.52-12.65c-.24-1.2.07-2.44.85-3.39.78-.95 1.93-1.5 3.16-1.5 1.69 0 3.23 1.06 3.82 2.64l5.53 14.57c.07.18.04.38-.06.53a.58.58 0 01-.48.25zm-9.26-1.16h8.42l-5.24-13.79a2.946 2.946 0 00-2.74-1.9c-.88 0-1.71.39-2.27 1.07s-.78 1.57-.61 2.43l2.43 12.18z"
      fill={color}
    />
    <path
      d="M27.36 50.61c-.24 0-.47-.16-.55-.4l-6.98-21.87c-.1-.3.07-.63.38-.73.3-.1.63.07.73.38l6.98 21.87c.1.3-.07.63-.38.73-.06.02-.12.03-.18.03z"
      fill={color}
    />
    </g>
  </svg>
);

export default Salon;
